module.exports =  {
    bindings: {},
    controller: btiListController,
    templateUrl: 'bti/components/bti-list.html'
}

btiListController.$inject = [
    'btiDataService',
    'notificationsService'
];

function btiListController(
    btiDataService,
    notificationsService
) {
    var vm = {
        service: btiDataService,
        changeActiveBti: btiDataService.changeActiveBti,
        isLoading: false,
        loadMore: loadMore
    };
    return vm;

    function loadMore() {
        vm.isLoading = true;
        btiDataService.loadMoreBtis().then(function () {
            notificationsService.publish('bti-page-changed');
            vm.isLoading = false;
        });
    }
}